<template>
    <div class="animate-pulse pt-2 ml-12 pl-1">
        <div class="h-8 w-1/4 rounded bg-gray-200 mb-6" />
        <div class="h-24 w-2/3 w-full rounded bg-gray-200" />
        <div class="h-12 w-2/3 rounded bg-gray-200 mt-2" />
    </div>
</template>

<script>
    export default {};
</script>
